import { JetView } from 'webix-jet';
import {
    profile, // User profile configuration
    devConfig, // Development configuration settings
    countries, // List of countries
    paymentSystem, // Payment system configurations
    cashDesks, // Cash desk configurations
    agentList, // List of agents
} from 'config/config';

/**
 * FilterRequestsAgentView class extends JetView to create a filter form for agent requests.
 */
export default class FilterRequestsAgentView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        const left = {
            // Left section of the form
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Input for Id
                            name: 'Id',
                            type: 'number',
                            label: _("<span class='icon-id'></span> Id"),
                            labelPosition: 'top',
                            placeholder: _('Id'),
                        },
                        {
                            view: 'richselect', // Dropdown for user type selection
                            name: 'Type',
                            localId: 'bonusStates:combo',
                            label: _('Tipo Usuario'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                {
                                    id: '',
                                    value: _('Todos'), // Option for all users
                                },
                                {
                                    id: '0',
                                    value: _('Agente'), // Option for agent
                                },
                                {
                                    id: '1',
                                    value: _('Afiliador'), // Option for affiliate
                                },
                            ],
                        },
                        {
                            view: 'text', // Input for User Id
                            type: 'number',
                            name: 'User',
                            label: "<span class='icon-drivers-license-o'></span>" + _('Usuario Id'),
                            labelPosition: 'top',
                            placeholder: _('Usuario Id'),
                        },
                    ],
                },
            ],
        };

        const upper_section = {
            // Upper section containing the left form
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 200 : 0, // Responsive height
            rows: [
                {
                    margin: 10,
                    cols: [left],
                },
            ],
        };

        const buttons = {
            // Button section for form actions
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 }, // Placeholder for layout
                        {
                            minWidth: 200,
                            view: 'button', // Button to add requirements
                            value: _('Añadir Requisito'),
                            type: 'form',
                            width: screen == 'small' ? 0 : 150,
                            click: () => {
                                this.app.callEvent('addRequirements:button', [[]]); // Trigger add requirements event
                            },
                        },
                        {
                            view: 'button', // Button to clear form
                            value: _('Limpiar'),
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                $$('myForm').setValues($$('myForm').getCleanValues()); // Reset form values
                                $$('Datepicker').setValue(''); // Clear datepicker
                            },
                        },
                        {
                            view: 'button', // Button to consult/filter requests
                            value: _('Consultar'),
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values for filtering
                                this.app.callEvent('requirementsAgent:filter', [filterdata]); // Trigger filter event
                            },
                        },
                    ],
                },
            ],
        };

        return {
            // Return the complete form configuration
            view: 'form',
            id: 'myForm',
            rows: [upper_section, buttons],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for form
            },
        };
    }

    /**
     * Initializes the view and sets up responsive behavior.
     * @param {Object} form - The form instance.
     */
    init(form) {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav').hide(); // Hide element if screen width is small
            }
        });
    }
}

// FILE DOCUMENTED
